"use strict";

var AOS = require('aos');
var jQueryBridget = require('jquery-bridget');
var Flickity = require('flickity');
var Headroom = require('headroom.js');
require('magnific-popup');
require('bootstrap/js/dist/dropdown.js');
require('bootstrap/js/dist/collapse.js');

Flickity.setJQuery( $ );
jQueryBridget( 'flickity', Flickity, $ );

(function( $ ) {

	$.fn.setImg = function() {
		var obj = $(this);
		var bg = $(obj).data('img');
		$('<img/>').attr('src', bg).on('load', function() {
			$(this).remove();
			$(obj).css('background-image', 'url(' + bg + ')');
			$(obj).addClass('loaded');
		});
	};

	$(function() {

		AOS.init();
    
		$('.imgToDiv').each(function(index, elem) {
			$(elem).setImg();
		});

		var myElement = document.querySelector(".header-mobile");
		var headroom  = new Headroom(myElement, {
			offset: 300
		});
		headroom.init();

		$('.carousel').flickity({
			prevNextButtons: false,
			pageDots: false,
			draggable: 'ontouchstart' in window,
			autoPlay: 3000,
			pauseAutoPlayOnHover: false
		});

		$('.menu-toggle').on('click', function() {
			$(this).toggleClass('open');
			$('body, .header-mobile, .mobile-menu').toggleClass('open');
		});

		$('.mobile-menu .menu .parent').on('click', function(e) {
			e.preventDefault();
			$('.mobile-menu .menu .item').toggleClass('out');
			$(this).toggleClass('in');
			if($(this).hasClass('in')) {
				$('.mobile-menu .menu').height($(this).find('.children').height() + 46);
			}
			else {
				$('.mobile-menu .menu').height(46 * 7);
			}
		});

		$('.mobile-menu .menu .children a').on('click', function(e) {
			e.stopPropagation();
		});

		$(".scrollto").on('click', function(e) {
			e.preventDefault();
			var target = $(this).data('target');
            $("html, body").animate({ scrollTop: $(target).offset().top }, "slow");
            return false;
        });

        $('.gallery-item').magnificPopup({
			type: 'image',
			removalDelay: 300,
			mainClass: 'mfp-fade',
			gallery: {
				enabled: true
			}
		});

		$('.collapse').on('show.bs.collapse hide.bs.collapse', function () {
			$(this).prev('.sub-title').toggleClass('open');
		});

	});

	$(window).on('load', function () {
		AOS.refresh();
	});

})(jQuery);